<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div [ngClass]="isDisabled()" style="display: flex; flex-direction: row;">
            <div class="robotoMedium"
                style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Current Grades</span>
            </div>
            <div
                style="color: white; padding: 10px; font-size: 11pt; display: flex; flex-direction: column; justify-content: center; align-items: center; flex: 1; text-align: center;">
                {{currentTerm | translate}}
            </div>
            <div *ngIf="!card.disabled" style="display: flex; flex: 1; flex-direction: row;">
                <div
                    style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center">
                    <button mat-stroked-button class="mat-card-button" (click)="viewAllGradesClick()"><span translate>Go
                            To Grades</span>
                    </button>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; flex: 1">
            <div *ngIf="!card.disabled" style="display: flex; flex-direction: column; flex: 1;">
                <div style="display: flex; flex-direction: row; justify-content: center; padding: 15px"
                    *ngIf="studentGrades.length == 0">
                    <span translate>No current grades available</span>
                </div>
                <div style="display: flex; flex-direction: column; padding-top: 10px; padding-bottom: 10px; overflow: hidden;"
                    *ngIf="studentGrades.length > 0">
                    <mat-table style="width: 100%;" multiTemplateDataRows [dataSource]="angularMatData"
                        class="mat-elevation-z0">

                        <!-- Grade Column -->
                        <ng-container matColumnDef="grade">
                            <mat-header-cell *matHeaderCellDef style="flex: .8;"><span translate>Grade</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let gradeRecord" style="flex: .8;">
                                <div *ngIf="gradeRecord.HasAttachedStandards" style="display: flex; flex: 1;">
                                    <a (click)="standardsClick(gradeRecord)"
                                        style="font-weight: normal; font-size: 10pt" translate>Standards</a>
                                </div>
                                <div *ngIf="!gradeRecord.HasAttachedStandards" style="display: flex; flex: 1;">
                                    {{gradeDisplayString(gradeRecord)}}</div>
                            </mat-cell>
                        </ng-container>

                        <!-- Course Name Column -->
                        <ng-container matColumnDef="courseName">
                            <mat-header-cell *matHeaderCellDef style="flex: 3;"><span translate>Course Name</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let gradeRecord" style="flex: 3;"> {{gradeRecord.CourseName}}
                            </mat-cell>
                        </ng-container>

                        <!-- Warning Column -->
                        <ng-container matColumnDef="warning">
                            <mat-header-cell *matHeaderCellDef style="flex: .5;"></mat-header-cell>
                            <mat-cell *matCellDef="let gradeRecord" style="flex: .5;">
                                <img *ngIf="gradeRecord.MissingAssignmentsCount > 0" style="height: 20px"
                                    src="./assets/images/warning_icon.png" />
                            </mat-cell>
                        </ng-container>

                        <!-- Tardy Count Column -->
                        <ng-container matColumnDef="tardy">
                            <mat-header-cell *matHeaderCellDef
                                style="flex: .5; justify-content: center; text-align: center">YTD<br /> Trdy
                            </mat-header-cell>
                            <mat-cell *matCellDef="let gradeRecord" style="flex: .5; justify-content: center">
                                <div *ngIf="gradeRecord.TardyYTD > 0">{{gradeRecord.TardyYTD}}</div>
                            </mat-cell>
                        </ng-container>

                        <!-- Absent Count Column -->
                        <ng-container matColumnDef="absent">
                            <mat-header-cell *matHeaderCellDef
                                style="flex: .5; justify-content: center; text-align: center">YTD<br /> Abs
                            </mat-header-cell>
                            <mat-cell *matCellDef="let gradeRecord" style="flex: .5; justify-content: center">
                                <div *ngIf="gradeRecord.AbsentYTD > 0">{{gradeRecord.AbsentYTD}}</div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="more">
                            <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;"
                                class="print-ignore"></mat-header-cell>
                            <mat-cell *matCellDef="let AH"
                                style="min-width:68px;max-width:68px;justify-content: center;" class="print-ignore">
                                <span aria-label="Expand row for more details">
                                    <i [ngClass]="checkExpanded(AH) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                        class="material-icons" aria-hidden="true"></i>
                                </span>
                            </mat-cell>
                        </ng-container>

                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                            <!-- Detail row can have standard html or another Angular Material table -->
                            <td mat-cell *matCellDef="let gradeRecord" [attr.colspan]="displayedColumns.length"
                                style="width:100%;" class="mat-detail-card">
                                <div style="width:100%; display: flex;" *ngIf="angularMatData.checkVisible(gradeRecord)">
                                    <div style="display: flex; flex-direction: column; flex: 1">
                                        <div style="display: flex; flex-direction: row">
                                            <span style="color: #757575" translate>Grade Status</span>
                                        </div>
                                        <div style="display: flex; flex-direction: row">
                                            {{gradeRecord.GradeStatus | translate}}
                                        </div>
                                    </div>
                                    <div *ngIf="showAssignmentLink"
                                        style="display: flex; flex-direction: column; flex: 1; justify-content: flex-end; align-items: center;">
                                        <a (click)="assignmentClick(gradeRecord)" translate>Assignments</a>
                                    </div>
                                    <div
                                        style="display: flex; flex-direction: column; flex: 1; justify-content: flex-end; align-items: center; color: red">
                                        <div *ngIf="gradeRecord.MissingAssignmentsCount > 0"
                                            style="text-align: center;;">
                                            {{gradeRecord.MissingAssignmentsCount}} <span translate>Missing</span>
                                            <div translate>in Last 30 Days</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: false"></mat-header-row>
                        <!-- Data rows -->
                        <mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" id="AHdataRow{{i}}"
                            tabindex="0" [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                            style="padding:0px;overflow: hidden;" matRipple (click)="toggleExpanded(row)"
                            (keydown)="rowKeyPress($event, row)">
                        </mat-row>
                        <!-- Detail row -->
                        <!-- 'overflow: hidden' is required for animation to render properly -->
                        <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                            [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'"
                            (@detailExpand.start)="$event.toState == 'expanded' ? angularMatData.setVisible(row, true) : null"
                            (@detailExpand.done)="$event.toState == 'collapsed' ? angularMatData.setVisible(row, false) : null"
                            style="overflow: hidden;" class="mat-detail-row">
                        </mat-row>
                    </mat-table>
                </div>
            </div>
            <!--If Disabled-->
            <div *ngIf="card.disabled" class="robotoMedium"
                style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
                <div style="padding: 50px;">
                    {{card.disabledMessage}}
                </div>
            </div>
        </div>
    </div>
</mat-card>